import cn from "classnames";
import { FormattedMessage as FM } from "react-intl";
import dates from "componentsv2/tools/dates";
import utils from "../services/appointment";
import { useContext } from "../store/useContext";

function AvailableTimeCard({ time, view, col, handleClick }) {
  const { context } = useContext();
  const { minStartTime, maxEndTime } = context;

  const start = new Date(time.start_date);
  const end = new Date(time.end_date);
  const day = dates.endOfDay(start).getDay() + 1;

  const { startHour } = utils.getHourRange(minStartTime, maxEndTime);
  const startMinutes =
    start.getHours() * 60 + Math.floor(start.getMinutes() / 5) * 5;
  const offsetMinutes = startHour * 60;

  const gridRow = 2 + Math.floor((startMinutes - offsetMinutes) / 5);

  const span = Number(
    (end.getTime() - start.getTime()) / (1000 * 60 * 5),
  ).toFixed(0);
  const style = `${gridRow} / span ${span}`;
  const colStart = view === "week" ? day : col || 1;

  function onClick(e) {
    e.stopPropagation();
    e.preventDefault();
    if (time.type === "availability") {
      handleClick(e);
    }
  }

  const color =
    time.type === "availability"
      ? "bg-emerald-50 border-emerald-500 text-emerald-500"
      : "bg-gray-50 border-gray-500 text-gray-500";
  return (
    <button
      type="button"
      className={`relative flex responsive-column-start rounded-lg mx-1 border opacity-50 ${color}`}
      style={{ gridRow: style, gridColumnStart: colStart }}
      onClick={onClick}
    >
      <div
        className={cn(
          "group absolute inset-1 flex flex-col overflow-y-auto rounded-lg p-2 text-sm ",
        )}
      >
        <span className="items-center flex justify-center flex-grow flex-1 my-auto">
          <FM id={`appointment_scheduling.${time.type}`} />
        </span>
      </div>
    </button>
  );
}

export default AvailableTimeCard;
